// timezone-aliases.ts (optional separate file)
export const TIMEZONE_ALIASES: Record<string, string> = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Etc/UTC': 'UTC'
  // add more aliases if needed
}
